import React from 'react';
import { useMediaQuery } from 'react-responsive';

import Modal from '../Modal';
import { ImageContainer, LargeImage, SliderContainer } from './styles/LightBoxModal.style';
import Slider from '../Slider';
import type { VehicleImages } from '../../types';

interface InputProps {
  images: VehicleImages[] | undefined | null;
  nonAudiImages?: string[] | null;
  modelName: string | undefined;
  handleIsOpen: () => void;
  isOpen: boolean;
  isUsed: boolean;
  nonAudi: boolean;
}

const LightBoxModal: React.FC<InputProps> = ({
  isOpen,
  handleIsOpen,
  images,
  nonAudiImages,
  modelName,
  isUsed,
  nonAudi,
}) => {
  const handleResetModal = () => {
    handleIsOpen();
  };
  const isMobile = useMediaQuery({
    query: '(max-width: 767px)',
  });
  const smallScreen = useMediaQuery({
    query: '(max-width: 767px)',
  });

  const isNew = !nonAudi && !isUsed;

  return (
    <Modal isOpen={isOpen} handleIsOpen={handleResetModal}>
      {isMobile ? (
        <>
          <ImageContainer data-testid="image-container">
            {isNew &&
              images?.map((vehicle: VehicleImages | undefined, i: number) => (
                <LargeImage
                  src={smallScreen ? `${vehicle?.url}?wid=1000` : vehicle?.url}
                  key={i}
                  alt={modelName}
                />
              ))}
            {!isNew &&
              nonAudiImages?.map((vehicle: string | undefined, i: number) => (
                <LargeImage src={vehicle} key={i} alt={modelName} />
              ))}
          </ImageContainer>
        </>
      ) : (
        <>
          <SliderContainer data-testid="slider-container">
            {!isNew ? (
              <Slider
                nonAudiImages={nonAudiImages}
                modelName={modelName || ''}
                isUsed={isUsed}
                nonAudi={nonAudi}
              />
            ) : (
              <Slider
                images={images}
                modelName={modelName || ''}
                isUsed={isUsed}
                nonAudi={nonAudi}
              />
            )}
          </SliderContainer>
        </>
      )}
    </Modal>
  );
};

export default LightBoxModal;
